import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import TextButton from 'components/TextButton';
import BackArrow from './arrow-back.png';
import './HomeExitIcon.css';

function HomeExitIcon({ url, onClick, className, icon }) {
  return url ? (
    <div className={'exit-icon ' + (className || '')}>
      <Link to={url} onClick={onClick}>
        <img src={icon || BackArrow} alt="Close" />
      </Link>
    </div>
  ) : (
    <div className={'exit-icon ' + (className || '')}>
      <TextButton onClick={onClick}>
        <img src={BackArrow} alt="Close" />
      </TextButton>
    </div>
  );
}

HomeExitIcon.propTypes = {
  url: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string
};

export default HomeExitIcon;
